export const styles = {
  amountSection: {
    wrapper: "-ml-[2%]",
    heading: "flex flex-col text-[30px] font-semibold font-ssp mb-5",
    box: "px-5 py-6 space-y-5 border border-gray-200 rounded-md w-[560px] h-[620px] shadow-xl",

    // You Send
    youSendContainer: "flex flex-col justify-center",
    youSendLabel: "font-semibold text-[19px]",
    youSendRow: "flex items-center mr-5",
    youSendInput: "rounded-l-md p-[3.4%] bg-blue-100 text-lg outline-none w-[430px]",
    youSendCurrencyBox: "flex py-[16px] w-[155px] space-x-4 border rounded-r-md",
    currencyImg: "rounded-[200px] w-7 h-7 ml-5",

    // They Receive
    theyReceiveContainer: "flex flex-col justify-center",
    theyReceiveLabel: "text-[19px] font-semibold",
    theyReceiveRow: "flex mr-5",
    theyReceiveInput: "w-[400px] rounded-l-md p-[3.4%] bg-blue-100 text-lg outline-none",
    lockIcon: "flex items-center justify-center pr-2 bg-blue-100 cursor-pointer",
    selectCurrencyMax: "rounded-[200px] w-7 h-7",

    // Purpose Code
    purposeContainer: "flex flex-col",
    purposeLabel: "text-[19px] font-semibold",
    familyWarning: "text-red-200 ml-[1px] text-wrap max-w-[370px]",

    // Exchange Rate
    rateContainer: "flex flex-col",
    rateLabel: "text-[19px] font-semibold",
    rateSubText: "font-normal text-[16px] text-gray-500",
    rateInputContainer: "flex items-center w-[370px] justify-between bg-blue-100 rounded-md",
    rateInput: "w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none",
    rateWarning: "font-semibold text-[13px] animate-fade",
    rateWarningStyle: { color: "#ff9966", fontWeight: "500" },

    // Vendor Code
    vendorContainer: "flex flex-col",
    vendorLabel: "text-[19px] font-semibold"
  },
  calculationSection: {
    wrapper: "h-full",
    heading: "mb-5 text-black text-[30px] font-semibold font-ssp",
    container: "border border-gray-200 rounded-md p-8 w-[560px] h-[620px] shadow-xl",

    subSectionWrapper: "-mt-3 ml-[32px] animate-fade duration-0",

    tcsRow: "flex items-center justify-between mt-[18px] relative",
    tcsLeft: "flex items-center text-xs font-normal text-black lg:text-base",
    tcsTooltip: "absolute top-8 bg-white p-2 rounded shadow-lg w-full",
    tcsRight: "flex items-center justify-between space-x-4",
    tcsAmount: "text-xs font-normal text-black lg:text-base",
    currency: "text-xs font-normal text-black lg:text-base",

    nostroToggle: "flex ml-2 cursor-pointer",
    nostroActive: "rounded px-2 text-white bg-primary-1050",
    nostroInactive: "rounded border px-2 text-black bg-[#E3E3E3]",

    panRow: "flex items-center gap-0 ml-3 mt-2",
    panAdd: "w-fit p-2 flex flex-row items-center justify-center text-primary-1050 font-bold cursor-pointer underline",
    panSelected: "w-fit p-2 flex flex-row items-center justify-center text-primary-1050 font-bold underline cursor-pointer",

    footer: "flex flex-row gap-5 justify-end w-full mt-6",
  },
}